/**
 * @description Environment values.
 */
export enum Env {
  DEV = 'DEV',
  QA = 'QA',
  PROD = 'PROD',
  STG = 'STG'
}



// WEBPACK FOOTER //
// ./src/environment/env.ts